import WeChatWebViewBridge from 'wechat-webview-bridge'

export default {
    install (Vue, options) {
        Vue.prototype.$wechat = this
        // 初始化
        this.ready = false
        this.bridge = new WeChatWebViewBridge({
            configHandler: this.configHandler.bind(this),
            apiList: [
                'menu:share:timeline',
                'menu:share:appmessage',
                'menu:share:qq',
                'menu:share:weiboApp',
                'menu:share:QZone',
                'geoLocation',
                'scanQRCode',
                'getBrandWCPayRequest',
            ],
            debug: (process.env.NODE_ENV !== 'production')
        })

        // 依赖注入
        this.$events = Vue.prototype.$events
        this.$api = Vue.prototype.$api

        // 绑定事件
        this.$events.on('before-mount', () => {
            if (!this.bridge.isWeChat) {
                return
            }
            // 等待微信原生桥初始化
            const wait = new Promise((resolve, reject) => {
                // 2 秒后返回 false
                setTimeout(() => resolve(false), 2e3)
            })
            return Promise.race([wait, this.bridge.load()])
                .then(result => {
                    if (result === false) {
                        // 初始化不成功或超时
                        window.location.reload()
                        // 永久等待
                        return new Promise((resolve, reject) => {})
                    }
                })
        })

        // 绑定事件
        this.$events.on('after-mount', () => {

            if (!this.bridge.isWeChat) {
                return
            }
            // 配置微信原生桥
            this.config()

        })

        // 绑定事件
        this.$events.on('before-create', () => {
            if (!this.bridge.isWeChat) {
                return
            }

            // 获取微信传递的 code 参数
            const searchParams = new URLSearchParams(window.location.search)
            const authState = searchParams.get('state')
            const authCode = searchParams.get('code')

            if (authState === 'authorize_wechat' && authCode) {
                // 持久化 authCode
                window.localStorage.setItem('wechatAuthCode', authCode)
            }
        })

        // 绑定事件
    },

    async configHandler ({ url }) {
        return this.$api.wechat.jsapiConfig({app:101,'shareurl':url })
            .then((res) => {
                let { timestamp, nonceStr, signature } = res.data;
                return { appId:process.env.VUE_APP_WECHAT_OFFICIAL_ACCOUNT_APPID, timestamp, nonceStr, signature }
            })
    },

    async config () {
        return this.bridge.config()
            .then(() => {
                this.ready = true
            },(res)=>{
                console.log(res)
            })
    },

    async authorize () {
        if (this.bridge.isWeChatBrowser) {
            return this.jsAuthorize()
        } else if (this.bridge.isWeChatMiniProgram) {
            return Promise.reject(new Error('暂不支持微信小程序'))
        }
        return Promise.reject(new Error('请在微信内打开使用'))
    },

    async jsAuthorize (requiresUserInfo = true) {
        const finalUri = encodeURIComponent(`${window.location.origin}${window.location.pathname}${window.location.search}`)
        const redirectUri = encodeURIComponent(`${process.env.VUE_APP_MP_CODE_DOMAIN}${finalUri}`)
        const scope = 'snsapi_base'
        const state = 'authorize_wechat'
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize` +
            `?appid=${process.env.VUE_APP_WECHAT_OFFICIAL_ACCOUNT_APPID}` +
            `&redirect_uri=${redirectUri}` +
            `&response_type=code` +
            `&scope=${scope}` +
            `&state=${state}` +
            `#wechat_redirect`
        // 永久等待
        return new Promise((resolve, reject) => {
            // 3 秒后抛出异常
            setTimeout(() => {
                reject(new Error('您必须同意微信授权方可继续使用。'))
            }, 3e3)
        })
    },

    geoLocation () {
        return this.bridge.load()
            .then(() => {
                return this.bridge.invoke('geoLocation')
                    .then(({ latitude, longitude }) => {
                        return { latitude, longitude }
                    })
            })
    },
    scanQRCode () {
        return this.bridge.load()
            .then(() => {
                return this.bridge.invoke('scanQRCode',{needResult:1}).then((res)=>{
                    if(res.errMsg==='scanQRCode:ok'){
                        if(this.bridge.isAndroid){
                            return res.resultStr;
                        }else if(this.bridge.isIOS){
                            let resultStr = JSON.parse(res.resultStr)
                            return resultStr.scan_code.scan_result;
                        }else{
                            return res.resultStr;
                        }
                    }else{

                    }

                },(error)=>{
                    return '';
                })
            })
    },
    imagePreview ({ urls, current }) {
        return this.bridge.load()
            .then(() => {
                return this.bridge.invoke('imagePreview', { urls, current })
            })
    },
    onMenuShareTimeline ({ title, description, link, imageUrl, callbacks }) {
        callbacks || (callbacks = {})
        return this.bridge.on('menu:share:timeline', () => {
            return this.bridge.invoke('shareTimeline', {
                title: title || window.document.title,
                desc: description || window.document.title,
                img_url: imageUrl || '',
                link: link || window.location.href,
                type: 'link',
                data_url: ''
            })
                .then(data => {
                    callbacks.success && callbacks.success(data)
                })
                .catch(error => {
                    if (error.message === 'cancel') {
                        callbacks.cancel && callbacks.cancel()
                        return
                    }
                    callbacks.fail && callbacks.fail(error)
                })
        })
    },

    onMenuShareAppMessage ({ title, description, link, imageUrl, callbacks }) {
        callbacks || (callbacks = {})
        return this.bridge.on('menu:share:appmessage', () => {
            return this.bridge.invoke('sendAppMessage', {
                title: title || window.document.title,
                desc: description || window.document.title,
                img_url: imageUrl || '',
                link: link || window.location.href,
                type: 'link',
                data_url: ''
            })
                .then(data => {
                    callbacks.success && callbacks.success(data)
                })
                .catch(error => {
                    if (error.message === 'cancel') {
                        callbacks.cancel && callbacks.cancel()
                        return
                    }
                    callbacks.fail && callbacks.fail(error)
                })
        })
    },

    updateShareData (options) {
        if (this.bridge.isWeChatBrowser) {
            return this.updateShareDataForJsApi(options)
        }
        if (this.bridge.isWeChatMiniProgram) {
            return Promise.reject(new Error('暂不支持微信小程序'))
        }
    },

    updateShareDataForJsApi ({ title, titleForTimeline, titleForAppMessage, description, link, imageUrl }) {
        return Promise.resolve()
            .then(() => {
                return this.bridge.load()
            })
            .then(() => {
                return this.config()
            })
            .then(() => {
                // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
                this.onMenuShareTimeline({
                    title: (titleForTimeline || title),
                    description,
                    link,
                    imageUrl,
                    callbacks: {
                        success: res => {
                            this.$events.emit('wechat-share-timeline')
                            this.$events.emit('wechat-share')
                        }
                    }
                })

                // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
                this.onMenuShareAppMessage({
                    title: (titleForAppMessage || title),
                    description,
                    link,
                    imageUrl,
                    callbacks: {
                        success: res => {
                            this.$events.emit('wechat-app-message')
                            this.$events.emit('wechat-share')
                        }
                    }
                })
            })
    }
}
